<template>
  <div v-if="totalCount > 0">
    <div class="menus" v-if="computedMenu.length>1">
      <div v-for="(item, idx) in computedMenu" :key="`sel-menu-${idx}`"
        class="sel-menu-item unselect" :class="{'sel-menu-item-selected': item.id === selMenu.selected}"
        @click="selMenu.selected = item.id">{{ item.label }}</div>
    </div>
    <template v-for="(item, idx) in menus">
      <template v-if="(selMenu.selected === 0 || item.id === selMenu.selected) && item.count > 0">
        <div class="product-item-wrapper" :key="`menu-${idx}`">
          <div class="padding-top-60 padding-bottom-28">
            <span class="h5">{{ item.label }}</span>
            <span class="h5 primary margin-left-4">{{ item.count }}</span>
          </div>
          <ListProductAppMarket :menu="item" :shadow="true" :products="item.products"></ListProductAppMarket>
        </div>
      </template>
    </template>
  </div>
</template>

<script>

  import ListProductAppMarket from "./ListProductAppMarket";
  export default {
    name: "Market",
    components: {
      ListProductAppMarket
    },
    props: {
      search: {
        type: String
      }
    },
    computed: {
      computedMenu() {
        let menu = this.selMenu.menus.filter(i => this.menus.find(m => m.products.length>0 && m.id === i.id));
        if(menu.length>1) {
          menu.splice(0,0,{
            label: '전체',
            id: 0
          });
        }
        return menu;
      },
    },
    data() {
      return {
        totalCount: 0,
        selMenu: {
          selected: 0,
          menus: []
        },
        selectedMenu: 0,
        orders: [],
        list: [],
        menus: [],
        recent:false,
        qfields: 'id,name,simple_desc,img,price,partner.img,partner.name,category1,category2,preview_url,tags,params',
        current_page: 1
      }
    },
    created() {
      this.init();
    },
    watch: {
      search() {
        this.init();
      }
    },
    methods: {
      async init() {

        this.list = [];
        this.menus = [];
        this.orders = [];

        // 메뉴
        let url = `${this.masterBackendUrl}public/category?parent_id=46`;
        let res = await this.$axios.get(url);
        this.selMenu.menus = this.cloneItem(res.data);
        this.selMenu.menus.splice(0,0,{
          label: '전체',
          id: 0
        });

        let searchQuery = `&search_keyword=${this.search}`;
        this.totalCount = 0;
        for(let data of res.data) {
          let prod_res = await this.$axios.get(`${this.masterBackendUrl}user/0/mapping/product?fields=${this.qfields}${searchQuery}&page_num=1&page_length=100&category=${data.id}`);
          data.products = this.setStatus(prod_res.data.data);
          data.count = prod_res.data.count;
          this.totalCount += data.count;
        }
        this.menus = res.data;
        this.$emit('count', this.totalCount);


        // 주문 기록
        res = await this.$axios.get(`${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/v1/service/${this.$store.getters.masterService.service_id}/app_order`);
        this.orders = res.data;

      },
      setStatus(arr) {
        for (const data of arr) {
          let app = this.orders.filter(i => i.products[0].id === data.id && i.status <= 2);
          data.status = app.length>0 ? app[0].status : 0;

          let grade = data.params.filter(i => i.name === '플러그인 등급');
          if(grade.length > 0 && grade[0].value.length > 0 && grade[0].value[0].name !== '기본') {
            data.grade = 1;
          } else {
            data.grade = 0;
          }
        }
        arr.sort((a,b)=> a.status - b.status).sort((a,b) => a.grade - b.grade);
        return arr;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import 'market_style.styl'

  .cat-selected
    position absolute
    left 0
    bottom 0
    width 100%
    background-color $primary
    height 3px

  .cat-wrapper
    display grid
    grid-template-columns repeat(4, 1fr)
    max-width 420px
    margin auto

  .cat-st
    flex 0 0 auto
    position relative
    padding 20px 0
    text-align center

  .product-item-wrapper
    border-bottom 1px solid $gray1
    padding-bottom 56px

  .product-item-wrapper:last-child
    border-bottom 0

  .container-wrapper
    background-color $gray3
    min-height 100vh
    padding-bottom 40px

  .menus
    display flex
    gap 0 8px
    .sel-menu-item
      border-radius 50px
      padding 6px 14px
      color $main
      background-color white
      border 1px solid #dddddd
      font-size 14px
      font-weight 500
    .sel-menu-item-selected
      color white
      background-color $main
</style>
